import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useEffect, useState } from 'react'

import styles from './PhoneNumberSearchbar.module.scss'

const PhoneNumberSearchbar = ({ query, setQuery }) => {
  const [searchText, setSearchText] = useState(query)

  useEffect(() => {
    setQuery(searchText)
  }, [searchText, setQuery])

  return (
    <div className={styles.phoneNumberSearchBar}>
      <TextInput
        label="Filter phone numbers"
        onChangeValue={setSearchText}
        value={searchText}
        type="search"
      />
    </div>
  )
}

export default PhoneNumberSearchbar
